import React from 'react';
import PropTypes from 'prop-types';
import OnboardingLayout from 'components/OnboardingLayout';
import ProgressBar from 'components/ProgressBar';
import { useGlobalState } from 'hooks/useGlobalState';
import { waitingMessages } from './utils';
import styles from './WaitingScreen.module.scss';

export default function WaitingScreen({ showProgressBar }) {
  const [{ waitingScreen }] = useGlobalState();
  const { waitingMessage: currentMessage } = waitingScreen;

  return (
    waitingScreen.visible && (
      <div className={styles.overlay} data-testid="waitingScreen">
        <OnboardingLayout classes={styles} promptEnabled={false}>
          <div className={styles.imgWrap}>
            <img
              data-testid="WaitingScreen_image"
              alt="New instance loading... "
              src="/assets/images/timeout-warning.svg"
            />
          </div>
          <h2 className={styles.h2}>{waitingMessages[currentMessage]}</h2>
          {showProgressBar && <ProgressBar />}
        </OnboardingLayout>
      </div>
    )
  );
}

WaitingScreen.propTypes = {
  showProgressBar: PropTypes.bool,
};

WaitingScreen.defaultProps = {
  showProgressBar: false,
};
